var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 481,
    viewBox: "0 0 480 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.734 442.742L203.683 405.254L231.153 403.538L220.205 441.026L192.734 442.742Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.934 201.67L187.226 179.144L214.675 177.42L225.376 199.955L197.934 201.67Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.048 177.152L198.631 137.466L226.118 135.747L214.525 175.426L187.048 177.152Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.6 304.334L133.192 302.485L259.345 354.455L229.745 356.314L103.6 304.334Z",
    fill: "#17181C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.159 126.008L249.752 124.159L227.477 134.66L197.868 136.512L220.159 126.008Z",
    fill: "#17181C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.143 77.0024L215.164 63.8211L240.207 62.2623L272.192 75.4354L247.143 77.0024Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.047 417.912L299.238 390.736L323.646 389.211L268.469 416.385L244.047 417.912Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.248 240.327L201.712 203.437L226.746 201.873L316.29 238.768L291.248 240.327Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.066 95.7672L305.014 58.279L332.495 56.5686L321.546 94.0567L294.066 95.7672Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.42 56.3124L262.911 39.2134L287.961 37.6463L329.463 54.7536L304.42 56.3124Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M323.316 307.454L292.613 242.246L320.067 240.537L350.771 305.745L323.316 307.454Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M300.335 388.663L323.464 309.448L350.944 307.738L327.806 386.947L300.335 388.663Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.774 128.353L297.1 97.5825L322.142 96.0238L396.816 126.78L371.774 128.353Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4185 356.458L104.247 305.683L229.364 357.239L229.772 357.407L230.172 357.218L252.453 346.708L252.86 346.516L252.986 346.084L263.895 308.752L264.004 308.381L263.834 308.033L251.81 283.413L251.643 283.072L251.292 282.927L158.276 244.604L126.989 178.133L151.764 93.2737L210.809 64.1897L246.594 78.9399L247.622 79.364L247.935 78.2957L259.167 39.8346L303.039 57.9071L291.747 96.5736L291.495 97.4361L292.326 97.7785L370.394 129.948L355.565 180.722L220.54 125.083L220.132 124.914L219.732 125.103L197.441 135.607L197.034 135.799L196.908 136.231L184.728 177.958L184.621 178.324L184.785 178.668L196.417 203.139L196.583 203.487L196.939 203.634L290.34 242.116L321.634 308.578L298.14 389.047L239.086 418.125L203.301 403.375L202.272 402.951L201.96 404.019L190.727 442.48L146.845 424.401L158.147 385.741L158.399 384.879L157.568 384.536L89.4185 356.458Z",
    fill: "#2A2B30",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M357.573 180.984L372.369 130.32L399.846 128.594L385.049 179.258L357.573 180.984Z",
    fill: "#17181C",
    stroke: "#F8FFE4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "homepage/static/media/dollar.25169fb60d6c612793f81d4601e2b1a5.svg";
export { ForwardRef as ReactComponent };